import { createTimeline, stagger } from 'animejs';

export default () => {
    const dmbaHero = document.querySelector('.dmba-hero__title-highlight');
    if (!dmbaHero) return; // Exit if DMBA hero not on page

    // Create timeline for cycling through highlight values
    // Only loop if there are multiple phrases
    let phrases = document.querySelectorAll('.dmba-hero__highlight-phrase');
    let timeline = createTimeline({ loop: phrases.length > 1 });

    phrases.forEach((phrase) => {
        timeline
            // Fade in letters with stagger (typewriter effect)
            .add(phrase.children, {
                ease: 'easeInOutQuad',
                opacity: '1',
                duration: 10,
                delay: stagger(80), // Match homepage 80ms stagger
            })
            // Hold visible
            .add(phrase.children, {
                opacity: '1',
                duration: 2000,
                translateX: [-20, 0],
                translateY: 'initial',
                delay: stagger(0),
            });

        // Only fade out if looping (multiple phrases)
        if (phrases.length > 1) {
            timeline.add(phrase.children, {
                ease: 'easeInOutQuad',
                opacity: '0',
                duration: 300,
                delay: stagger(0),
            });
        }
    });

    // Sticky CTA bar visibility control
    const heroElement = document.querySelector('.dmba-hero');
    const stickyBar = document.querySelector('[data-dmba-sticky-ctas]');

    if (heroElement && stickyBar) {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    // Hero is visible, hide sticky bar
                    stickyBar.classList.remove('dmba-hero-sticky-ctas--visible');
                } else {
                    // Hero scrolled out of view, show sticky bar
                    stickyBar.classList.add('dmba-hero-sticky-ctas--visible');
                }
            },
            { threshold: 0 }
        );

        observer.observe(heroElement);
    }
};
